module.exports = __webpack_public_path__ + "static/media/brand4-large.c168b047.jpg";